export default "__VITE_ASSET__DD9pwHdE__"